import { render, staticRenderFns } from "./VtIconButton.vue?vue&type=template&id=fd0bef6e&scoped=true&"
import script from "./VtIconButton.vue?vue&type=script&lang=js&"
export * from "./VtIconButton.vue?vue&type=script&lang=js&"
import style0 from "./VtIconButton.vue?vue&type=style&index=0&id=fd0bef6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0bef6e",
  null
  
)

export default component.exports